import { Theme } from '@emotion/react';
import { Button, styled, SxProps } from '@mui/material';

interface ButtonProps {
    btnText: string;
    sx?: SxProps<Theme>;
    onClick?: () => void;
}

const StyledBtn = styled(Button)(() => ({
    backgroundColor: "none",
    border: "1px solid #000",
    color: "#000",
    padding: "6px 20px"

}))

const WhiteButtonComponent = ({btnText,onClick, sx}: ButtonProps) => {
  return (
    <StyledBtn onClick={onClick} sx={sx}>{btnText}</StyledBtn>
  )
}

export default WhiteButtonComponent;